// PartidosPage.js
import React from "react";
import MyPageBanner from "../components/MyPageBanner";
import field1 from "../images/field1.png";
import "./PartidosPage.css"; // CSS for the PartidosPage component
import PartidosDia from "../components/PartidosDia";

const PartidosPage = () => {
  return (
    <div className="partidos-page">
      <MyPageBanner
        imageUrl={field1}
        text="Partidos"
        subtitle="Todos los partidos del día, de todas las ligas."
      />
      <div className="partidos-page-fixtures-container">
        <PartidosDia />
      </div>
    </div>
  );
};

export default PartidosPage;
